import { combineReducers } from 'redux';
import uiRootReducer from './ui-enhancer';

import { upgrade as UpgradeReducer } from './components/upgrade/upgrade-reducer';
import { helpwidget as HelpWidgetReducer } from './components/helpwidget/helpwidget-reducer';
import { walkthru as WalkThruReducer } from './components/walkthru/walkthru-reducer';

const upgrade = uiRootReducer(UpgradeReducer, 'UPGRADE');
const helpwidget = uiRootReducer(HelpWidgetReducer, 'HELPWIDGET');
const walkthru = uiRootReducer(WalkThruReducer, 'WALKTHRU');

export default combineReducers({ helpwidget, upgrade, walkthru });



// WEBPACK FOOTER //
// ./src/app/stores/ui/ui-reducer.js